/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CloseAction/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import React from 'react'
import Shortcut from 'DesignSystem/Shortcut/react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconClose from 'DesignSystem/Svgs/TysiaIconClose/index'



/** @type {import('Simple/types.js').View} */
export default function CloseAction({
  children,
  viewPath = "/App/Account/PatientOverlay/Content/Content/CloseAction"
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let onPress = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="CloseAction.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 size="small"
 onClick={onClick}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconClose
{...childProps}
  viewPath={`${viewPath}/TysiaIconClose`}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
<Shortcut
  viewPath={`${viewPath}/Shortcut`}
 keys="esc"
 onPress={onPress}
/>
</div>
{children}
</React.Fragment>)
}